import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {SignalEntityQuery} from '../../state/signal-entity.store';
import {ItemsState, ItemsStore} from './items.store';
import {Item} from '../../models/policy.model';

@Injectable({providedIn: 'root'})
export class ItemsQuery extends SignalEntityQuery<Item, ItemsState> {
    constructor(protected store: ItemsStore) {
        super(store);
    }

    getItems(): Observable<any> {
        return this.selectAll();
    }
}
